<template>
  <ElDialog
    :title="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHANGE_BUDGET')"
    :visible="value"
    width="600px"
    @open="initializeModel"
    @close="close"
  >
    <div class="row">
      <ElForm
        ref="campaignCreditModel"
        class="columns"
        :model="campaignCreditModel"
        :rules="campaignCreditRules"
        label-position="top"
        @submit.native.prevent="validateAndSubmit"
      >
        <ElFormItem
          :label="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHARGE_CREDIT_TYPE')"
        >
          {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHARGE_FROM_CREDIT') }}
        </ElFormItem>

        <ElFormItem
          :label="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHARGE_AMOUNT')"
          prop="credit"
        >
          <ElInput
            v-model.number="campaignCreditModel.credit"
            :disabled="isLoading"
          />
        </ElFormItem>

        <p v-show="campaignCreditModel.credit">
          <strong>
            {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.FINAL_CHARGE_AMOUNT') }}:
          </strong>
          {{ currencyFormat(campaignCreditModel.credit) }} {{ $t('RIALS') }}
          <br />
        </p>

        <!-- dirty hack until ElementUI ends up with a solution -->
        <input v-show="false" type="submit" />
      </ElForm>

      <EditCampaignBudgetModalAdBudgetInfo
        class="columns"
        :budget-allocation-limit="budgetAllocationLimit"
      />
    </div>

    <BudgetError v-if="hasBudgetOverflowError" />

    <div slot="footer" class="dialog-footer">
      <ElButton
        type="primary"
        :loading="isLoading"
        :disabled="hasBudgetOverflowError"
        @click.native.prevent="validateAndSubmit"
      >
        {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHARGE_BUTTON') }}
      </ElButton>
      <ElButton type="text" :plain="true" @click.native.prevent="close">
        {{ $t('CANCEL') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import { format as currencyFormat } from '@/utils/number';
import EditCampaignBudgetModalAdBudgetInfo from './EditCampaignBudgetModalAdBudgetInfo';
import BudgetError from '../../../../../common/BudgetError';

import form from '@/mixins/form';

export default {
  name: 'EditCampaignBudgetModal',
  components: {
    EditCampaignBudgetModalAdBudgetInfo,
    BudgetError,
  },
  mixins: [form],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    budgetAllocationLimit: {
      type: Number,
      required: true,
    },
    credit: {
      type: Number,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      campaignCreditModel: {
        credit: this.credit,
        creditType: 'credit',
        gift: null,
      },
    };
  },
  computed: {
    campaignCreditRules() {
      const rules = {
        required: true,
        message: this.$t('VALIDATION_REQUIRED_ERR'),
        trigger: 'blur',
      };

      return {
        credit: [
          rules,
          {
            type: 'number',
            min: 0,
            trigger: 'blur',
            message: this.$t('VALIDATION_MORE_THAN_ZERO'),
          },
        ],
      };
    },
    hasBudgetOverflowError() {
      return this.campaignCreditModel.credit > this.budgetAllocationLimit;
    },
  },
  methods: {
    currencyFormat,
    clearValidate() {
      this.$refs.campaignCreditModel.clearValidate();
    },
    initializeModel() {
      this.campaignCreditModel = {
        credit: this.credit,
        creditType: 'credit',
        gift: null,
      };
    },
    close() {
      this.$emit('input', false);
    },
    validateAndSubmit() {
      if (!this.isValid('campaignCreditModel') || this.hasBudgetOverflowError) {
        return false;
      }

      this.$emit('submit', this.campaignCreditModel);
    },
  },
};
</script>
